export default __webpack_public_path__ + "locales/ja-JP/People.json?hash=f05e36e185cca54c2dbdc08537b2d612";